<div id="not-authorized">
  <div class="not-authorized">
    <div class="not-authorized-404">
      <h2>You do not have authorizations to view this page. Please contact your administrator.</h2>
    </div>
  </div>
</div>
